import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Accordion, AccordionDetails, AccordionSummary, Stack } from '@mui/material';
import { FlowDurationUnits } from 'flow-schema';
import { useState } from 'react';

import { Text } from 'common';

import { BlockValueTemplateField } from '../../../ConfigFields/CodeMirror/FlowTemplate';
import { BlockDurationField } from '../../../ConfigFields/Duration';
import { ScriptContextType } from '../../../ConfigFields/DynamicField/ScriptContext';
import { SharedSubFlowV2BlockFormFields } from '../../SubFlow/v2/SharedFormFields';
import { SubflowOrSkillV2FlowKinds } from '../../constants';

enum Section {
  SubFlow = 'SubFlow',
  AdvancedSettings = 'AdvancedSettings',
}

export function IteratorBlockFormFields() {
  const [expandedSection, setExpandedSection] = useState<Section | null>(Section.SubFlow);

  return (
    <Stack gap={2}>
      {/* List to Iterate at the top */}
      <BlockValueTemplateField
        fieldName="config.items"
        label="List to iterate"
        helperText="The list of items to iterate over"
      />

      <Stack>
        {/* Subflow Accordion */}
        <Accordion
          variant="elevation"
          expanded={expandedSection === Section.SubFlow}
          onChange={() =>
            setExpandedSection(expandedSection === Section.SubFlow ? null : Section.SubFlow)
          }
        >
          <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="subflow-content">
            <Text variant="heading5" bold>
              Subflow
            </Text>
          </AccordionSummary>
          <AccordionDetails>
            <SharedSubFlowV2BlockFormFields
              fieldNamePrefix="config.subFlow"
              scriptContextType={ScriptContextType.Iteration}
              variant="SubflowPicker"
              allowedFlowKinds={SubflowOrSkillV2FlowKinds}
            />
          </AccordionDetails>
        </Accordion>

        {/* Advanced Settings Accordion */}
        <Accordion
          variant="elevation"
          expanded={expandedSection === Section.AdvancedSettings}
          onChange={() =>
            setExpandedSection(
              expandedSection === Section.AdvancedSettings ? null : Section.AdvancedSettings
            )
          }
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="advanced-settings-content"
          >
            <Text variant="heading5" bold>
              Advanced settings
            </Text>
          </AccordionSummary>
          <AccordionDetails>
            <Stack gap={2}>
              <BlockDurationField
                fieldName="config.iterationStepDuration"
                unitFieldNameSuffix="units"
                allowedUnits={[
                  FlowDurationUnits.Hours,
                  FlowDurationUnits.Minutes,
                  FlowDurationUnits.Seconds,
                ]}
                toggleLabel="Time interval"
                valueLabel="Time interval"
                valueHelperText="Duration to wait between processing items"
                variant="BlockValueTemplate"
              />
            </Stack>
          </AccordionDetails>
        </Accordion>
      </Stack>
    </Stack>
  );
}
